<template>
  <div class="perfil-page">

    <!-- ── SEÇÃO: Avatar + Dados ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-account-circle-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Meu Perfil</div>
          <div class="form-section__sub">Foto e informações do seu usuário</div>
        </div>
      </div>
      <div class="form-section__body">
        <v-row dense>
          <!-- Avatar -->
          <v-col cols="12" md="3" class="d-flex flex-column align-center" style="gap:12px">
            <v-avatar size="200" v-ripple class="avatar-wrap" @click="triggerFileInput">
              <v-img :src="avatar" v-if="avatar" />
              <v-img v-else src="../../assets/default_user.png" />
            </v-avatar>
            <v-file-input
              ref="fileInput"
              label="Alterar foto"
              accept="image/*"
              @change="alterarFoto"
              v-model="fotoUpload"
              style="display:none"
            />
            <v-btn text rounded small color="error" @click="preDeletePerfilImage">
              <v-icon left small>mdi-delete-forever</v-icon>
              Remover imagem
            </v-btn>
          </v-col>

          <!-- Dados -->
          <v-col cols="12" md="9">
            <div class="dialog-section-label">Dados do usuário</div>
            <v-row dense>
              <v-col cols="12">
                <h2 class="perfil-name">{{ user.name }}</h2>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.email"
                  outlined dense readonly color="#0052A0"
                  label="E-mail"
                  prepend-inner-icon="mdi-email-outline"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="user.perfilacesso"
                  outlined dense readonly color="#0052A0"
                  label="Perfil de Acesso"
                  prepend-inner-icon="mdi-shield-account-outline"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </div>

    <!-- ── SEÇÃO: Alterar Senha ── -->
    <div class="form-section">
      <div class="form-section__header">
        <div class="form-section__icon-wrap">
          <v-icon color="#0052A0" size="20">mdi-lock-outline</v-icon>
        </div>
        <div>
          <div class="form-section__title">Segurança</div>
          <div class="form-section__sub">Altere sua senha de acesso quando necessário</div>
        </div>
        <v-spacer />
        <v-switch
          v-model="trocarSenha"
          :value="trocarSenha"
          label="Alterar senha"
          color="#0052A0"
          hide-details
          inset
          class="mt-0 pt-0"
        />
      </div>

      <div class="form-section__body" v-if="trocarSenha">
        <v-form ref="form" v-model="validCad" lazy-validation>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="passwordCurrent"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                label="Senha Atual"
                outlined dense color="#0052A0"
                required
                @click:append="show1 = !show1"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="passwordNew"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                label="Nova Senha"
                outlined dense color="#0052A0"
                required
                :rules="senhaRules1"
                @click:append="show2 = !show2"
              />
              <div v-html="forcaSenha" style="font-size:0.78rem;margin-top:-8px" />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="passwordConfirm"
                :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show3 ? 'text' : 'password'"
                label="Confirmar Nova Senha"
                outlined dense color="#0052A0"
                required
                :rules="senhaRules1"
                @click:append="show3 = !show3"
              />
            </v-col>
            <v-col cols="12">
              <v-btn color="#0052A0" rounded elevation="0" :disabled="!validCad" @click="alterarSenha" class="px-6">
                <v-icon left color="#FFD400" small>mdi-arrow-right-bold</v-icon>
                <span style="color:#FFD400;font-weight:700;font-size:13px">Alterar Senha</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </div>

    <!-- ── RODAPÉ ── -->
    <div class="form-section form-section--last">
      <v-btn outlined rounded elevation="0" color="#0052A0" :to="{ name: 'Home' }" class="px-6">
        <v-icon left small>mdi-arrow-left-bold</v-icon>
        <span style="font-size:13px">Voltar</span>
      </v-btn>
    </div>

  </div>
</template>

<script>
export default {
  data: () => ({
    user: {},
    avatar: null,
    fotoUpload: null,
    trocarSenha: false,
    forcaSenha: "",
    show1: false,
    show2: false,
    show3: false,
    profilePic: null,
    passwordCurrent: null,
    passwordNew: null,
    passwordConfirm: null,
    validCad: false,
    senhaRules1: [
      (v) => !!v || "Senha é obrigatória",
      (v) =>
        /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(v) ||
        "A senha deve conter maiúsculas, minúsculas, números e caracteres especiais",
    ],
  }),
  mounted() {
    this.buscarDados();
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    buscarDados() {
      this.$http.get("meuperfil").then((response) => {
        this.user = response.data;
        this.avatarView();
      });
    },
    preDeletePerfilImage() {
      this.$swal({
        title: "Remover imagem de perfil?",
        text: "Você não poderá reverter isso!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0052A0",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.post("removerImagePerfilWeb").then(() => {
            this.$swal({ icon: "success", title: "Imagem removida com sucesso", position: "top-center", showConfirmButton: true })
              .then(() => window.location.reload());
          });
        }
      });
    },
    avatarView() {
      if (!this.user.picture) return;
      this.$http.get("verPdfUser/" + this.user.picture, { responseType: "blob" }).then(
        (response) => {
          const blob = new Blob([response.data]);
          this.avatar = URL.createObjectURL(blob, { type: response.headers.map["content-type"] });
        },
        () => {}
      );
    },
    alterarFoto() {
      if (!this.fotoUpload) return;
      const formData = new FormData();
      formData.append("doc", this.fotoUpload);
      this.$http.post("alterarImagePerfilWeb", formData).then(() => {
        this.$swal({ icon: "success", title: "Foto atualizada com sucesso", position: "top-center", showConfirmButton: true })
          .then(() => window.location.reload());
      });
    },
    alterarSenha() {
      this.$http.post("alterarsenha", {
        passwordCurrent: this.passwordCurrent,
        passwordNew:     this.passwordNew,
        passwordConfirm: this.passwordConfirm,
      }).then(
        () => {
          this.$swal({ icon: "success", title: "Senha alterada com sucesso", position: "top-center", showConfirmButton: true });
        },
        (response) => {
          this.$swal({ icon: "error", title: "Não foi possível efetuar a operação", text: response.data.message, position: "top-center", showConfirmButton: true });
        }
      );
    },
  },
};
</script>

<style scoped>
.perfil-page {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.form-section {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 32px;
  margin-bottom: 32px;
}
.form-section--last { border-bottom: none; padding-bottom: 0; margin-bottom: 0; }

.form-section__header {
  display: flex; align-items: flex-start; gap: 12px; padding: 0 0 18px 0; flex-wrap: wrap;
}
.form-section__icon-wrap {
  width: 34px; height: 34px; background: #e8f0fe; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.form-section__title { font-family: 'Inter', sans-serif; font-size: 0.92rem; font-weight: 700; color: #1e293b; }
.form-section__sub   { font-family: 'Inter', sans-serif; font-size: 0.78rem; color: #94a3b8; margin-top: 1px; }
.form-section__body  { padding: 0; }

.dialog-section-label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 12px;
}

.perfil-name {
  font-family: 'Inter', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 16px;
}

.avatar-wrap {
  cursor: pointer;
  border: 3px solid #e8f0fe;
  border-radius: 50%;
  transition: border-color 0.2s;
}
.avatar-wrap:hover { border-color: #0052A0; }

.perfil-page >>> .v-input__slot { background-color: #fff !important; box-shadow: none !important; }
.perfil-page >>> .v-label { font-family: 'Inter', sans-serif !important; font-size: 0.85rem !important; }

@media (max-width: 768px) { .perfil-page { padding: 16px; } }
</style>
